<div class="container-fluid">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <div class="forms d-block comparewiki-table-header">

    <div class="row m-0">
      <div class="col-lg-12">
        <p-table #dt2 class="kbmadmintable" #pt [value]="reservations" dataKey="compareWikiReservationId" selectionMode="single"
          [(selection)]="compareWikiReservation" [loading]="loading" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
          scrollHeight="900px" [globalFilterFields]="['propertyCode', 'reservationId', 'guestName', 'reservationStatus']"
          [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

          <!--<ng-template pTemplate="caption">
          <div class="row m-0">
            <div class="col-lg-12">
              <div class="d-block text-end justify-content-between align-items-center">
                <h1 style="float: left;margin: 6px;">CompareWikiReservations</h1>
                <span>
                  &lt;!&ndash;clear filters&ndash;&gt;
                  <button *ngIf="showFilter" pButton pRipple class="p-button-text"
                    style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
                  (click)="reloadPage()">Clear Filters</button>

                  &lt;!&ndash;add new&ndash;&gt;
                  &lt;!&ndash; <button *ngIf="!outlineNewButton" pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
                (click)="onOpenFormAdd()">New CompareWikiReservation +</button>
                <button *ngIf="outlineNewButton" pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
                (click)="onOpenFormAdd()">New CompareWikiReservation +</button> &ndash;&gt;
              </span>
            </div>
          </div>
        </div>
      </ng-template>-->
      <ng-template pTemplate="caption">
        <div class="flex">
          <p-iconField iconPosition="left" class="ml-auto position-relative">
            <p-inputIcon>
              <span class="p-input-icon">
                <i class="pi pi-search"></i>
              </span>

            </p-inputIcon>
            <input
              pInputText
              type="text"
              (input)="dt2.filterGlobal($event.target.value, 'contains')"
              placeholder="Search keyword" />
          </p-iconField>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          @for (col of columns; track col) {
            <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
              {{col.header}}
              <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
            </th>
          }
        </tr>
        <tr>
          <td class="propertycode-filter">
            <p-columnFilter
              type="text"
              [showMenu]="false"
              matchMode="contains"
              field="propertyCode"
              placeholder="Property name"
              ariaLabel="Property name">
            </p-columnFilter>
          </td>
          <td>
            <p-columnFilter
              field="createDate" [showMenu]="false" >
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <input dt2 [(ngModel)]="createDate" pInputText type="date"
                  (input)="filter($event.target.value, 'createDate', 'in')">
              </ng-template>
            </p-columnFilter>
          </td>
          <td class="filter-input">
            <p-columnFilter
              type="text"
              matchMode="contains"
              [showMenu]="false"
              field="reservationId"
              placeholder="reservation #"
            ariaLabel="reservationId"></p-columnFilter>
          </td>
          <td class="filter-input">
            <p-columnFilter
              type="text"
              field="slConfNumber"
              matchMode="contains"
              [showMenu]="false"
              placeholder="SL ConfId"
            ariaLabel="slConfNumber"></p-columnFilter>
          </td>
          <td>
            <!-- <p-columnFilter field="reservationStatus" matchMode="equals" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown dt2
                [(ngModel)]="reservationStatus1"
                [options]="reservationStatuses"
                (onChange)="filter($event.value, 'reservationStatus', 'in')"
                placeholder="Select One"
                [showClear]="true" appendTo="body" optionLabel="name" optionValue="value">
                <ng-template let-option pTemplate="item">
                  <span>{{option.name}}</span>
                </ng-template>
              </p-dropdown>
            </ng-template>
          </p-columnFilter> -->
        </td>
        <td class="filter-input">
          <p-columnFilter
            type="text"
            field="guestName"
            matchMode="contains"
            [showMenu]="false"
            placeholder="Guest Name"
            ariaLabel="guestName">
          </p-columnFilter>
        </td>
        <td>
          <p-columnFilter
            field="checkInDate" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input dt2 [(ngModel)]="checkInDate" pInputText type="date"
                (input)="filter($event.target.value, 'checkInDate', 'in')">
            </ng-template>
          </p-columnFilter>
        </td>
        <td>
          <p-columnFilter
            field="checkOutDate" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input dt2 [(ngModel)]="checkOutDate" pInputText type="date"
                (input)="filter($event.target.value, 'checkOutDate', 'in')">
            </ng-template>
          </p-columnFilter>
        </td>
        <td>
          <p-columnFilter type="boolean" field="existInRU"></p-columnFilter>
        </td>
        <td>
          <p-columnFilter type="boolean" field="existInWiki"></p-columnFilter>
        </td>
        <td>
          <p-columnFilter type="boolean" field="existInYieldMax"></p-columnFilter>
        </td>
      </tr>
      <!--<tr *ngIf="showFilter">
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'compareWikiReservationId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>-->
  </ng-template>
  <ng-template pTemplate="body" let-reservation>
    <tr>
      <td>{{reservation?.propertyCode}} </td>
      <td>{{reservation?.createDate | date}}</td>
      <td>{{reservation?.reservationId}}</td>
      <td>{{removeNull(reservation?.slConfNumber)}}</td>
      <td [style.background-color]="getResStatusColor(reservation.reservationStatus)">
      {{getResStatusName(reservation.reservationStatus)}}</td>
      <td>{{reservation?.guestName}}</td>
      <td>{{reservation?.checkInDate | date}}</td>
      <td>{{reservation?.checkOutDate | date}}</td>
      <td [style.background-color]="getSyncColor(reservation.existInRU)">
        <span style="float:none" (click)="syncReservationRUtoWiki(reservation)">
          <a>
            SYNC to WIKI
            <i class="pi pi-refresh" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;"></i>
          </a>
        </span>
      </td>
      <td [style.background-color]="getSyncColor(reservation.existInWiki)" >{{reservation.existInWiki}}
      </td>
      <td [style.background-color]="getSyncColor(reservation.existInYieldMax)">{{reservation.existInYieldMax}}
        <span style="float:none">
          <a>
            <i class="pi pi-refresh" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;" (click)="synchReservationToYieldMax(reservation.reservationId)"></i>
          </a>
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
</div>
</div>
</div>
</div>
